import {
    getSearchResults as getSearchResultsEndeca,
    getSearchDetailResult as getSearchDetailResultEndeca,
} from './Endeca/EndecaSearchApi';

export const getSearchResults = (params, regionZone, version, disableNewAutoSuggestion) =>
    getSearchResultsEndeca(params, regionZone, version, disableNewAutoSuggestion);

export const getSearchDetailResult = (searchTerm) => getSearchDetailResultEndeca(searchTerm);
